import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import classnames from 'classnames'

import Clickable from '../../Clickable'
import AutoFocus from '../../AutoFocus'
import ImagePopup from '../ImagePopup'

import style from './style.css'
import sharedStyle from '../sharedStyle.css'

import replaceUnderscores from '../../../lib/replaceUnderscores'

function PhraseChoice (props) {
  let correctnessClass
  const isDisabled = props.isComplete || props.isRemoved || props.isAnswered

  if (isDisabled) {
    if (props.isCorrect) {
      correctnessClass = style.correct
    } else if (props.isRemoved) {
      correctnessClass = style.removed
    } else if (props.isComplete && props.isAnswered === false) {
      correctnessClass = style.complete
    } else {
      correctnessClass = style.incorrect
    }
  } else {
    if (props.isAnswered === true && props.isCorrect === true) {
      correctnessClass = style.correct
    } else if (props.isAnswered === true && props.isCorrect === false) {
      correctnessClass = style.incorrect
    } else {
      correctnessClass = style.answerChoice
    }
  }

  return (
    <Clickable
      className={correctnessClass}
      onClick={!isDisabled ? props.onPress : null}
      disabled={isDisabled}
      data-test-id="sentenceClick"
    >
      <span dangerouslySetInnerHTML={{ __html: props.text }} />
    </Clickable>

  )
}
PhraseChoice.propTypes = {
  value: PropTypes.number.isRequired,
  text: PropTypes.string.isRequired,
  onPress: PropTypes.func.isRequired,
  isCorrect: PropTypes.bool.isRequired,
  isAnswered: PropTypes.bool.isRequired,
  isRemoved: PropTypes.bool.isRequired,
  isComplete: PropTypes.bool.isRequired
}

export default class SentenceClick extends Component {
  constructor(props){
    super(props);
    this.inputFormRef = React.createRef();
  }

  phraseClick (index) {
    this.props.onAnswer(index.toString())
  }

  formatSentenceClickQuestion (text, choices, isComplete) {
    const sentence = []

    const placeholder = text.replace(/\n/, '<br/>').split(/({{.*?}})/)
    let outerChoiceIndex = 0

    _.forEach(placeholder, (item, index) => {
      if (_.startsWith(item, '{{') && _.endsWith(item, '}}')) {
        item = item.replace(/[{{}}]/g, '')
        // scope the choice index so it doesn't change in the PhraseChoice jsx below
        const choiceIndex = outerChoiceIndex

        sentence.push(
          <PhraseChoice
            key={index}
            value={choices[choiceIndex].value}
            text={item}
            onPress={() => this.phraseClick(choiceIndex)}
            isCorrect={choices[choiceIndex].isCorrect}
            isAnswered={choices[choiceIndex].isAnswered}
            isRemoved={choices[choiceIndex].isRemoved}
            isComplete={isComplete}
          />
        )
        outerChoiceIndex++
      } else {
        sentence.push(<span key={index} dangerouslySetInnerHTML={{ __html: item }} />)
      }
    })

    return (
      <span className={style.sentence}>
        {sentence}
      </span>
    )
  }

  componentDidMount() {
    this.inputFormRef.current.addEventListener('focusin', this.handleFocusIn);
  }

  componentWillUnmount() {
    this.inputFormRef.current.removeEventListener('focusin', this.handleFocusIn);
  }

  handleFocusIn = (event) => {
    const target = event.target;
    if (target && target.scrollIntoView) {
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };
  
  render () {
    const question = this.props.question
    const prompt = question.prompt
    const label = prompt.substr(0, prompt.indexOf('\n'))
    const text = prompt.substr(prompt.indexOf('\n')).trim()

    const sentence = this.formatSentenceClickQuestion(text, question.choices, question.isComplete)

    return (
      <div data-test-id="activityQuestion">
        <AutoFocus tabIndex="0">
          <ImagePopup>
            <h2
              className={classnames(sharedStyle.prompt, style.prompt)}
              tabIndex="0"
              ref={(header) => { this.questionHeader = header }}
            >
              {replaceUnderscores(label)}
            </h2>
          </ImagePopup>
        </AutoFocus>
        <p data-test-id="sentenceClickSentences" ref={this.inputFormRef}>
          {sentence}
        </p>
      </div>
    )
  }
}

SentenceClick.propTypes = {
  onAnswer: PropTypes.func.isRequired,
  question: PropTypes.shape({
    prompt: PropTypes.string.isRequired,
    isComplete: PropTypes.bool
  })
}
